export default __webpack_public_path__ + "static/media/ETH-BTC.0d2a437c.png";